<template>
  <div class="block-slider-img-container" :class="{'is-video' : type === 'video'}">
    <slot/>
    <transition name="fade-opacity-lazy">
      <img v-if="type === 'img'" :key="img" :src="getUrl(img)" alt="bg">
      <video
          :key="img"
          v-else class="video" loop playsinline :controls="true">
        <source :src="getUrl(img)" type="video/mp4"/>
      </video>
    </transition>
  </div>
</template>

<script>
export default {
  name: "BlockImgSlider",
  props: {
    type: {
      type: String,
      default: 'img'
    },
    img: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .block-slider-img-container {
    top: 0;
    left: 0;
    z-index: 0;
    position: absolute;
    width: 100%;
    &.is-video {
      margin: 0 auto;
      width: fit-content;
    }
    & video {
      width: 100%;
      height: 100%;
    }

    & img {
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 3024px){
    .block-slider-img-container {
      height: 608px;
    }

  }


  @media (max-width: 2100px) {
    .block-slider-img-container {
      height: 578px;
    }
  }

  @media (max-width: 1920px) {
    .block-slider-img-container {
      height: 500px;
    }
  }
  @media (max-width: 1600px) {
    .block-slider-img-container {
      height: 420px;
    }
  }
  @media (max-height: 800px) {
    .block-slider-img-container {
      height: 360px;
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .block-slider-img-container {
      height: 420px;
    }
  }

  @media (max-width: 1133px) {
    .block-slider-img-container {
      height: 360px;
    }
  }
  @media (max-width: 769px) {
    .block-slider-img-container {
      height: 320px;
    }
    //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .block-slider-img-container {
      height: 600px;
    }
  }

</style>